export interface Course {
  id: string;
  title: string;
  instructor: string;
  category: string;
  level: string;
  price: number | null;
  durationHours: number | null;
  lessonsCount: number | null;
  language: string;
  description: string;
  objectives: string;
  cover: string;
  postedAt: string;
}

export const courseCategories = [
  'Développement Web',
  'Intelligence Artificielle',
  'Marketing Digital',
  'Business & Entrepreneuriat',
  'Design',
  'Data Science',
  'Langues',
  'Cybersécurité',
];

export const courseLevels = ['Débutant', 'Intermédiaire', 'Avancé', 'Tous niveaux'];

export const mockCourses: Course[] = [
  {
    id: 'course-1',
    title: 'Développement Web Full-Stack (React & Node.js)',
    instructor: 'Matthew DOTSE',
    category: 'Développement Web',
    level: 'Débutant',
    price: 25000,
    durationHours: 32,
    lessonsCount: 48,
    language: 'Français',
    description:
      'Apprenez à créer des sites et applications web modernes de A à Z. Ce cours vous guide pas à pas pour maîtriser le front-end avec React, le back-end avec Node.js et les bases de données. Idéal pour débuter une carrière de développeur web.',
    objectives:
      'Comprendre les bases de HTML, CSS et JavaScript\nConstruire des interfaces modernes avec React\nCréer une API avec Node.js et Express\nConnecter une base de données PostgreSQL\nDéployer votre première application en ligne',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20web%20development%20workspace%20with%20a%20laptop%20showing%20colorful%20code%20editor%2C%20HTML%20CSS%20JavaScript%20code%20on%20screen%2C%20clean%20minimal%20desk%20with%20coffee%20cup%20and%20notebook%2C%20warm%20natural%20lighting%2C%20professional%20tech%20education%20photography&width=800&height=500&seq=course-web-01&orientation=landscape',
    postedAt: '2026-08-19',
  },
  {
    id: 'course-2',
    title: 'Intelligence Artificielle avec Python',
    instructor: 'Apeiron Academy',
    category: 'Intelligence Artificielle',
    level: 'Intermédiaire',
    price: 45000,
    durationHours: 40,
    lessonsCount: 56,
    language: 'Français',
    description:
      'Plongez dans l\'intelligence artificielle et le machine learning avec Python. Découvrez les algorithmes fondamentaux, la manipulation de données et la création de modèles prédictifs avec des bibliothèques comme scikit-learn et TensorFlow.',
    objectives:
      'Maîtriser Python pour la data science\nComprendre les algorithmes de machine learning\nManipuler les données avec pandas et NumPy\nEntraîner et évaluer des modèles prédictifs\nConstruire un premier projet d\'IA complet',
    cover:
      'https://readdy.ai/api/search-image?query=Artificial%20intelligence%20concept%20with%20neural%20network%20visualization%20on%20a%20computer%20screen%2C%20futuristic%20technology%20interface%2C%20clean%20modern%20desk%20with%20warm%20soft%20lighting%2C%20professional%20tech%20education%20photography%2C%20high%20detail&width=800&height=500&seq=course-ai-02&orientation=landscape',
    postedAt: '2026-08-18',
  },
  {
    id: 'course-3',
    title: 'Marketing Digital & Réseaux Sociaux',
    instructor: 'DigitalBridge Togo',
    category: 'Marketing Digital',
    level: 'Débutant',
    price: 15000,
    durationHours: 20,
    lessonsCount: 30,
    language: 'Français',
    description:
      'Maîtrisez les fondamentaux du marketing digital : réseaux sociaux, publicité en ligne, référencement et stratégie de contenu. Apprenez à faire grandir une marque et à attirer des clients sur Internet.',
    objectives:
      'Créer une stratégie de contenu efficace\nAnimer les réseaux sociaux comme un pro\nLancer des campagnes publicitaires en ligne\nComprendre les bases du SEO\nAnalyser les performances avec des indicateurs clés',
    cover:
      'https://readdy.ai/api/search-image?query=Digital%20marketing%20concept%20with%20social%20media%20icons%20and%20analytics%20dashboard%20on%20a%20laptop%20screen%2C%20smartphone%20beside%20showing%20growth%20charts%2C%20modern%20bright%20office%2C%20warm%20lighting%2C%20professional%20editorial%20photography&width=800&height=500&seq=course-marketing-03&orientation=landscape',
    postedAt: '2026-08-17',
  },
  {
    id: 'course-4',
    title: 'Créer sa plateforme digitale (No-Code / Low-Code)',
    instructor: 'Matthew DOTSE',
    category: 'Business & Entrepreneuriat',
    level: 'Intermédiaire',
    price: 30000,
    durationHours: 25,
    lessonsCount: 34,
    language: 'Français',
    description:
      'Vous avez une idée de plateforme ? Apprenez à la concrétiser rapidement avec les outils no-code et low-code. De la conception à la mise en ligne, ce cours vous montre comment bâtir un produit numérique sans être développeur.',
    objectives:
      'Concevoir l\'architecture d\'une plateforme\nChoisir les bons outils no-code\nCréer une base de données et une interface\nAjouter l\'authentification et les paiements\nLancer et faire grandir votre plateforme',
    cover:
      'https://readdy.ai/api/search-image?query=Entrepreneur%20building%20a%20digital%20platform%20on%20a%20laptop%20showing%20a%20website%20builder%20interface%2C%20modern%20startup%20workspace%2C%20creative%20atmosphere%2C%20warm%20natural%20light%2C%20professional%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=course-platform-04&orientation=landscape',
    postedAt: '2026-08-16',
  },
  {
    id: 'course-5',
    title: 'Design UI/UX avec Figma',
    instructor: 'CreativeLab Studio',
    category: 'Design',
    level: 'Débutant',
    price: 20000,
    durationHours: 18,
    lessonsCount: 26,
    language: 'Français',
    description:
      'Apprenez à concevoir des interfaces modernes et agréables avec Figma. De la recherche utilisateur à la création de prototypes interactifs, maîtrisez le processus complet du design produit.',
    objectives:
      'Prendre en main Figma de A à Z\nComprendre les principes du design UI/UX\nCréer des wireframes et maquettes\nPrototyper des interactions\nPréparer un design prêt pour le développement',
    cover:
      'https://readdy.ai/api/search-image?query=UI%20UX%20designer%20working%20on%20wireframes%20and%20color%20palettes%20in%20Figma%20on%20a%20laptop%2C%20modern%20creative%20studio%20with%20plant%20and%20desk%20lamp%2C%20warm%20natural%20lighting%2C%20professional%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=course-design-05&orientation=landscape',
    postedAt: '2026-08-15',
  },
  {
    id: 'course-6',
    title: 'Data Science & Analyse de données',
    instructor: 'Insight Analytics',
    category: 'Data Science',
    level: 'Avancé',
    price: 50000,
    durationHours: 45,
    lessonsCount: 60,
    language: 'Français',
    description:
      'Transformez les données en décisions stratégiques. Ce cours avancé couvre l\'analyse statistique, la visualisation et la modélisation de données avec Python et SQL pour devenir data analyst ou data scientist.',
    objectives:
      'Maîtriser SQL pour interroger les données\nRéaliser des analyses statistiques avec Python\nCréer des visualisations percutantes\nConstruire des tableaux de bord\nCommuniquer des insights avec impact',
    cover:
      'https://readdy.ai/api/search-image?query=Data%20analyst%20working%20with%20charts%20and%20graphs%20on%20multiple%20monitors%2C%20data%20visualization%20dashboards%2C%20modern%20office%20with%20warm%20lighting%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20clean%20composition&width=800&height=500&seq=course-data-06&orientation=landscape',
    postedAt: '2026-08-14',
  },
  {
    id: 'course-7',
    title: 'Entrepreneuriat & Business en Afrique',
    instructor: 'Matthew DOTSE',
    category: 'Business & Entrepreneuriat',
    level: 'Tous niveaux',
    price: null,
    durationHours: 15,
    lessonsCount: 22,
    language: 'Français',
    description:
      'Un cours gratuit pour apprendre à lancer et développer un business en Afrique. De l\'idée à la rentabilité, découvrez les stratégies, les outils et l\'état d\'esprit des entrepreneurs qui réussissent sur le continent.',
    objectives:
      'Valider une idée de business\nConstruire un modèle économique solide\nComprendre le marché africain\nTrouver ses premiers clients\nGérer la croissance de son entreprise',
    cover:
      'https://readdy.ai/api/search-image?query=African%20entrepreneur%20presenting%20a%20business%20plan%20in%20a%20modern%20office%2C%20confident%20professional%20in%20smart%20attire%2C%20warm%20lighting%2C%20growth%20and%20success%20atmosphere%2C%20professional%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=course-business-07&orientation=landscape',
    postedAt: '2026-08-13',
  },
  {
    id: 'course-8',
    title: 'Anglais professionnel pour les affaires',
    instructor: 'Langues Plus Academy',
    category: 'Langues',
    level: 'Débutant',
    price: 12000,
    durationHours: 24,
    lessonsCount: 36,
    language: 'Français',
    description:
      'Améliorez votre anglais professionnel pour communiquer avec confiance dans le monde des affaires. Vocabulaire métier, emails, réunions et présentations : tout ce qu\'il faut pour travailler à l\'international.',
    objectives:
      'Acquérir le vocabulaire des affaires\nRédiger des emails professionnels\nParticiper à des réunions en anglais\nPréparer des présentations\nAméliorer la prononciation et l\'écoute',
    cover:
      'https://readdy.ai/api/search-image?query=English%20language%20learning%20setup%20with%20books%2C%20notebook%20and%20headphones%20on%20a%20modern%20desk%2C%20laptop%20showing%20online%20course%2C%20warm%20natural%20lighting%2C%20professional%20education%20photography%2C%20high%20detail&width=800&height=500&seq=course-english-08&orientation=landscape',
    postedAt: '2026-08-12',
  },
];